exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".action-icon {\n  cursor: pointer; }\n\n.select-storage-profile::after {\n  right: 18px; }\n\n.sp-container {\n  margin-top: 10px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/app/components/compute/compute-vcd/org-vdc-wizard/storage-profile/storage-profile.scss
// module id = IhLb
// module chunks = 0